export default "assets/images/secured-paiement-37c64c7c.svg";